import { memo, useEffect, useState, useCallback, useMemo } from 'react';
import { Col, Container, Dropdown, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { BzModalBody, BzModal, BzModalHeader, BzModalTitle, BzButton, BzInputText, BzModalFooter, BzDropdown } from '../../components';
import { APP_INFO_PARAMS, DONT_MISS_WATCHLIST_NAME, LOCATIONS, LOCAL_STORAGE_KEYS, MY_HOLDINGS_WATCHLIST_NAME, WATCHLIST_GRID_INDEX } from '../../utils/global_variables';
import { handleModal } from '../../redux/actions/modals';
import { getColumnDef, updateActiveWatchlist, updateCurrentWatchlist, updateOpenWatchlist, updatedDashboardWatchlist } from '../../redux/actions/watchlist';
import { toastConfig } from '../../redux/actions/toast';
import { _checkForSpecialChars, _createAndAddScripsInWatchlist, _watchlistNameAlreadyExist } from '../../controllers';
import { addNewWatchlist } from '../../redux/actions/watchlist';
import { _isWatchlistSystemDefined } from '../../controllers';
import GlobalSearchRemoveExtraScripModal from './GlobalSearchRemoveExtraScripModal';
import { setArrScripToBeAdded, updateGlobalAddScripWL } from '../../redux/actions/globalSearch';
import { deepClone, getscripCountPerWatchlist, getAppInfoData, getDecryptLocalStorage, getScripDisplayDescription, setEncryptLocalStorage, isGuestUser } from '../../utils/global_functions';
import { useLocation, useNavigate } from 'react-router';

const GlobalSearchAddScripModal = ({ ...props }) => {

    const dispatch = useDispatch();

    const isWatchlistPresent = useSelector(state => state.watchList.isWatchlistPresent);
    const modals = useSelector(state => state.modals.modals);
    const [activeOption, setActiveOption] = useState('CreateWatchList');
    const [objSelectedWatchList, setObjSelectedWatchList] = useState({});
    const [arrFilteredWatchLists, setArrFilteredWatchLists] = useState([]);
    const { appInfo } = useSelector(state => state.appInfo);
    const [strNewWatchListName, setStrNewWatchListName] = useState('');
    const userId = useSelector(state => state?.auth?.userId);
    const [bIsScripExists, setBIsScripExists] = useState(false);
    const [arrExistingScrips, setArrExistingScrips] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});
    const arrScripsToBeAdded = useSelector(state => state?.globalSearch?.arrScripsToBeAdded);
    const activeWatchList = useSelector(state => state.watchList.activeWatchList);
    const openWatchlists = useSelector(state => state.watchList.openWatchlists);
    const dashboardWatchlists = useSelector(state => state.watchList.dashboardWatchlists);
    const watchlists = useSelector(state => state.watchList.watchlists);
    const maxWatchlist = getAppInfoData(APP_INFO_PARAMS.APP_MAX_PROFILE_COUNT);

    let location = useLocation();
    const navigate = useNavigate();


    useEffect(() => {
        let arrFilterWatchLists = [];
        if (watchlists?.length > 0) {
            for (let i = 0; i < watchlists.length; i++) {
                let response = _isWatchlistSystemDefined(watchlists[i]);
                if (response.status) {
                    arrFilterWatchLists.push(watchlists[i]);
                }
            }
            setArrFilteredWatchLists(arrFilterWatchLists);
            if (arrFilterWatchLists.length > 0) {
                if (Object.keys(objSelectedWatchList).length === 0) {
                    setObjSelectedWatchList(arrFilterWatchLists[0]);
                    let firstOption = { name: arrFilterWatchLists[0].sWatchListName, length: arrFilterWatchLists[0].scrips.length };
                    setSelectedOption(firstOption);
                    setEncryptLocalStorage('selectedOption', JSON.stringify(firstOption));
                }
            }
        }

    }, [watchlists]);

    useEffect(() => {
        const savedOption = JSON.parse(getDecryptLocalStorage('selectedOption'));
        if (savedOption) {
            setSelectedOption(savedOption);
        }
    }, [arrScripsToBeAdded, objSelectedWatchList]);

    const checkScripExists = () => {
        const arrExistingScripsData = [];
        for (let i = 0; i < arrScripsToBeAdded?.length; i++) {
            let objScripData = objSelectedWatchList.scrips.find(eachScrip => eachScrip[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === arrScripsToBeAdded[i][WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]);
            if (objScripData) {
                arrExistingScripsData.push(objScripData);
            }
        }
        return arrExistingScripsData;
    };

    //Ameersha N : Breeze BT-96728 Global Search feature - global search when a set of scrips are added to the watchlist when click on view this will do the neccssary -- 06-11-2023 --Start
    const handleViewClick = useCallback((objGlobalAddScripWL) => {
        const watchlistCopy = deepClone(watchlists);
        const openWatchlistCopy = deepClone(openWatchlists);
        const checkWLExists = watchlistCopy.find(eachWL => eachWL?.id === objGlobalAddScripWL?.id);
        if (checkWLExists) {
            const nWLInOpenExistsIndex = openWatchlistCopy.findIndex(eachOpenWl => eachOpenWl?.id === objGlobalAddScripWL?.id);
            if (nWLInOpenExistsIndex > -1) {
                openWatchlistCopy[nWLInOpenExistsIndex] = objGlobalAddScripWL;
                dispatch(updateOpenWatchlist([...openWatchlistCopy]));
                dispatch(updateActiveWatchlist({ ...objGlobalAddScripWL }));
            }
            else {
                openWatchlistCopy.push(objGlobalAddScripWL);
                dispatch(updateOpenWatchlist([...openWatchlistCopy]));
                dispatch(updateActiveWatchlist({ ...objGlobalAddScripWL }));
            }

        } else { }
        if (location.pathname !== LOCATIONS.WATCHLIST) {
            dispatch(handleModal([{ "EVENTS_DETAILS": false }]));
            navigate(LOCATIONS.WATCHLIST);
        } else { }
        dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
        dispatch(toastConfig({}));
    }, [openWatchlists, watchlists, dispatch, location, navigate]);
    //Ameersha N : Breeze BT-96728 Global Search feature -- 06-11-2023 --End 

    //Ameersha N : Breeze BT-96728 Global Search feature -Used to create a new watchlist from globalsearch scrips --Start -- 12-12-2023
    const onAddCustomNewWatchlist = useCallback((scripsToBeAdded = [], customNewWatchlistName) => {
        let scripsAllowedPerWatchlist = getscripCountPerWatchlist();
        let handleCreateAndAddingScrips = _createAndAddScripsInWatchlist(watchlists, scripsToBeAdded, customNewWatchlistName, isWatchlistPresent, scripsAllowedPerWatchlist, userId);
        if (!handleCreateAndAddingScrips.status) {
            dispatch(toastConfig({ autoDismiss: true, show: true, message: handleCreateAndAddingScrips.message }));
        } else {
            dispatch(addNewWatchlist(handleCreateAndAddingScrips?.data?.objWatchlistPayload))?.then(() => {
                if (location?.pathname === LOCATIONS.WATCHLIST) {
                    dispatch(toastConfig({
                        autoDismiss: true,
                        show: true,
                        message: `${arrScripsToBeAdded.length === 1 ? `'${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} ${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} ${getScripDisplayDescription(arrScripsToBeAdded[0])}'` : arrScripsToBeAdded.length} ${arrScripsToBeAdded.length === 1 ? `has` : `Scrips have`} been added to ${handleCreateAndAddingScrips?.data?.objWatchlistPayload?.sWatchListName}`,
                    }));
                    if (isGuestUser()) {
                        dispatch(getColumnDef());
                    }
                } else {
                    dispatch(toastConfig({
                        autoDismiss: true,
                        show: true,
                        // Modifies message to include scrip name, exchange and strike price if one scrip is added or shows count of scrips added depending upon condition
                        message: `${arrScripsToBeAdded.length === 1 ? `'${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} ${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} ${getScripDisplayDescription(arrScripsToBeAdded[0])}'` : arrScripsToBeAdded.length} ${arrScripsToBeAdded.length === 1 ? `has` : `Scrips have`} been added to ${handleCreateAndAddingScrips?.data?.objWatchlistPayload?.sWatchListName}`,
                        button: [{
                            btnName: "View", className: 'btn  btn-solid ms-3', onClickHandler: () => {
                                handleViewClick(handleCreateAndAddingScrips?.data?.objWatchlistPayload);
                            }
                        }]
                    }));
                }

            });
            dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": false }]));
        }
    }, [appInfo, dispatch, isWatchlistPresent, userId, handleViewClick, watchlists]);
    //Ameersha N : Breeze BT-96728 Global Search feature --Start -- 14-12-2023

    const handleAddScripFromGlobalSearch = useCallback((e) => {
        e.preventDefault();
        if (activeOption === 'AddScripTo') {
            const arrSelectedScripDetails = objSelectedWatchList.scrips;
            let updatedScrips = [...arrScripsToBeAdded, ...arrSelectedScripDetails];
            const nAddedScripsCount = updatedScrips.length - objSelectedWatchList.scrips.length;
            if (updatedScrips.length <= 0) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Atleast 1 scrip should be present in ${objSelectedWatchList?.sWatchListName}` }));
            }
            else {

            }
            const arrScrips = updatedScrips?.map((scrip, i) => ({
                nMarketSegmentId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                nToken: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                nSequenceNo: i + 1,
                sSettings: null
            }));
            objSelectedWatchList['scrips'] = arrScrips;
            if (!bIsScripExists) {
                dispatch(updateCurrentWatchlist(objSelectedWatchList)).then(({ objResp, objWatchlistResp }) => {
                    //objWatchlistResp will have the updated watchlist resp from api with converted scrips into arryas -- 06-11-2023
                    objSelectedWatchList['scrips'] = updatedScrips;
                    //Ameersha N-30-11-2023 : Breeze -BT-96728 Global Search : issue : not updating dashbaord watchlist when scrips are added to active dashboard watchlist -Start
                    if (dashboardWatchlists?.id === objWatchlistResp?.id) {
                        dispatch(updatedDashboardWatchlist(objWatchlistResp));
                    } else { }
                    //Ameersha N-30-11-2023 : Breeze -BT-96728 Global Search : issue : not updating dashbaord watchlist when scrips are added to active dashboard watchlist -End
                    dispatch(updateGlobalAddScripWL(objWatchlistResp));
                    if (nAddedScripsCount < 0) {
                        dispatch(toastConfig({ autoDismiss: true, timer: 5000, show: true, message: `${nAddedScripsCount.toString().split('')[1]} scrips ${nAddedScripsCount === 1 ? 'has' : 'have'}  been removed in '${objSelectedWatchList?.sWatchListName}'` }));
                    } else {
                        let firstOption = { name: arrFilteredWatchLists[0].sWatchListName, length: arrFilteredWatchLists[0].scrips.length };
                        setSelectedOption(firstOption);
                        setEncryptLocalStorage('selectedOption', JSON.stringify(firstOption));
                        setObjSelectedWatchList(arrFilteredWatchLists[0]);
                        // Ameersha N : 06-11-2023 : BT-96728 Global Search feature – Issue - Toast message not disappearing automatically – Start
                        // Deepti B: 15/05/2024 : BT-109055 Price-Volume-View - View button should not display for opened watchlists - start
                        for (let i = 0; i < openWatchlists.length; i++) {
                            if (openWatchlists[i].sWatchListName === objWatchlistResp?.sWatchListName) {
                                dispatch(toastConfig({
                                    autoDismiss: true,
                                    timer: 5000,
                                    show: true,
                                    //message: `${nAddedScripsCount <= 1 ? arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL] : nAddedScripsCount}  ${nAddedScripsCount <= 1 ? 'has' : 'Scrips have'} been added to '${objSelectedWatchList?.sWatchListName}'`,
                                    // Modifies message to include scrip name, exchange and strike price if one scrip is added or shows count of scrips added depending upon condition
                                    message: `${nAddedScripsCount === 1 ? `'${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} ${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} ${getScripDisplayDescription(arrScripsToBeAdded[0])}'` : arrScripsToBeAdded.length} ${nAddedScripsCount === 1 ? `has` : `Scrips have`} been added to ${objSelectedWatchList?.sWatchListName}`,
                                }));
                                break;
                            } else if (i === openWatchlists.length - 1) {
                                dispatch(toastConfig({
                                    autoDismiss: true,
                                    timer: 5000,
                                    show: true,
                                    //message: `${nAddedScripsCount <= 1 ? arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL] : nAddedScripsCount}  ${nAddedScripsCount <= 1 ? 'has' : 'Scrips have'} been added to '${objSelectedWatchList?.sWatchListName}'`,
                                    // Modifies message to include scrip name, exchange and strike price if one scrip is added or shows count of scrips added depending upon condition
                                    message: `${nAddedScripsCount === 1 ? `'${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} ${arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} ${getScripDisplayDescription(arrScripsToBeAdded[0])}'` : arrScripsToBeAdded.length} ${nAddedScripsCount === 1 ? `has` : `Scrips have`} been added to ${objSelectedWatchList?.sWatchListName}`,
                                    button: (location?.pathname === LOCATIONS.WATCHLIST && activeWatchList?.sWatchListName === objWatchlistResp?.sWatchListName) ? [] : [{
                                        btnName: "View", className: 'btn  btn-solid ms-3', onClickHandler: () => {
                                            handleViewClick(objWatchlistResp);
                                        }
                                    }]
                                }));
                            }
                        }
                        // Deepti B: 15/05/2024 : BT-109055 Price-Volume-View - View button should not display for opened watchlists - End
                        // Ameersha N : 06-11-2023 : BT-96728 Global Search feature – Issue - Toast message not disappearing automatically – End
                    }

                });

                dispatch(setArrScripToBeAdded([]));

                dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': false }]));
            }
        }
        else {
            const objWatclistNameAlreadyExist = _watchlistNameAlreadyExist(watchlists, strNewWatchListName);
            if (objWatclistNameAlreadyExist?.status && strNewWatchListName?.length > 0 && watchlists?.length < maxWatchlist) {
                onAddCustomNewWatchlist(arrScripsToBeAdded, strNewWatchListName);
                dispatch(setArrScripToBeAdded([]));// Ameersha N : 14-12-2023 : BT-96728 Global Search feature
            } else {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: objWatclistNameAlreadyExist?.message }));
            }

        }

    }, [objSelectedWatchList, activeOption, appInfo, arrFilteredWatchLists, dashboardWatchlists,
        arrScripsToBeAdded, bIsScripExists, dispatch, handleViewClick, onAddCustomNewWatchlist, strNewWatchListName, watchlists]);

    useEffect(() => {
        if (arrScripsToBeAdded?.length > 0 && Object.keys(objSelectedWatchList).length > 0) {
            const response = checkScripExists();
            if (response.length > 0) {
                setArrExistingScrips(response);
                setBIsScripExists(true);
            }
            else {
                setBIsScripExists(false);
            }
        }
    }, [arrScripsToBeAdded, objSelectedWatchList, checkScripExists]);



    const handleClose = () => {
        dispatch(setArrScripToBeAdded([]));
        setStrNewWatchListName('');
        setSelectedOption('');
        setObjSelectedWatchList({});
        localStorage.removeItem(LOCAL_STORAGE_KEYS.SELECTED_OPTION);
        dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": false }], true));
    };

    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -Start
    useEffect(() => {
        const data = watchlists?.filter(eachWatchlist => eachWatchlist?.sWatchListName?.toLowerCase() !== MY_HOLDINGS_WATCHLIST_NAME?.toLowerCase() && eachWatchlist?.sWatchListName?.toLowerCase() !== DONT_MISS_WATCHLIST_NAME?.toLowerCase());
        if (data?.length > 0) {
            setActiveOption("AddScripTo");
        } else {
            setActiveOption("CreateWatchList");
        }
    }, [watchlists]);
    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -End
    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -Start
    const arrFilteredWatchlist = useMemo(() => {
        const data = watchlists?.filter(eachWatchlist => eachWatchlist?.sWatchListName?.toLowerCase() !== MY_HOLDINGS_WATCHLIST_NAME?.toLowerCase() && eachWatchlist?.sWatchListName?.toLowerCase() !== DONT_MISS_WATCHLIST_NAME?.toLowerCase());
        return data;
    }, [watchlists]);
    // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -End

    const handleOptionChange = useCallback((e) => {
        if (e.target.value === 'CreateWatchList') {
            if (watchlists?.length >= maxWatchlist) {
                dispatch(toastConfig({ autoDismiss: true, show: true, message: `Cannot create more than ${maxWatchlist} watchlists` }));
            } else {

                setActiveOption(e.target.value);
            }
        } else {
            // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -Start
            if (arrFilteredWatchlist?.length > 0) {
                setActiveOption(e.target.value);
            } else { }
            // Ameersha N : 14-12-2023 : BT-96728 Global Search feature -End
        }
    }, [arrFilteredWatchlist, watchlists, appInfo, dispatch]);
    //Ameersha N : Breeze BT-96728 Global Search feature- selecting watchlist value from dropdown -- 06-11-2023 --Start
    const handleSelectOption = (e) => {
        // e.stopPropagation();
        const watchlistData = watchlists.find(eachWL => eachWL.sWatchListName?.toLowerCase() === e.target.value?.toLowerCase());
        if (watchlistData) {
            let updatedOption = { name: watchlistData.sWatchListName, length: watchlistData.scrips.length };
            setObjSelectedWatchList(watchlistData);
            setSelectedOption(updatedOption);
            setEncryptLocalStorage('selectedOption', JSON.stringify(updatedOption));
        } else { }

    };
    //Ameersha N : Breeze BT-96728 Global Search feature -- 06-11-2023 --END

    const handleCreateNewWatchList = (e) => {
        if (!_checkForSpecialChars(e.target.value)?.status) {
            setStrNewWatchListName(e.target.value?.toUpperCase()); //AzeemK : [07-11-2023] : To accept value in uppper case - 07-11-2023
        }
    };

    const handleCancel = () => {
        dispatch(setArrScripToBeAdded([]));
        setSelectedOption('');
        setStrNewWatchListName('');
        setObjSelectedWatchList(arrFilteredWatchLists[0]);
        localStorage.removeItem(LOCAL_STORAGE_KEYS.SELECTED_OPTION);
        dispatch(handleModal([{ "GLOBAL_SEARCH_ADDSCRIP_MODAL": false }]));
    };

    const handleRemove = (e) => {
        dispatch(handleModal([{ "GLOBAL_SEARCH_REMOVE_EXTRASCRIPS_MODAL": true }]));
    };

    const nMaxScripToBeAdd = useMemo(() => {
        return getscripCountPerWatchlist();
    }, [appInfo]);
    // Hari K:30-09-2024: fixed add button disable mode-start
    const [isAddDisable, setisAddDisabl] = useState(true);
    useEffect(() => {
        if (activeOption == 'CreateWatchList') {
            if (strNewWatchListName?.length !== 0) {
                setisAddDisabl(false);
            } else { setisAddDisabl(true); }
        } else {
            // Deepti B. [BT-107398]: added condition if scrip which trying to add in a watchlist where it already exist then ADD button should disabled
            if (bIsScripExists || (objSelectedWatchList?.scrips?.length === nMaxScripToBeAdd && !bIsScripExists) || (arrScripsToBeAdded?.length + objSelectedWatchList?.scrips?.length) > nMaxScripToBeAdd) {
                setisAddDisabl(true);
            } else { setisAddDisabl(false); }
        }
    }, [activeOption, objSelectedWatchList, strNewWatchListName, nMaxScripToBeAdd, bIsScripExists, arrScripsToBeAdded]);
    // Hari K:30-09-2024: fixed add button disable mode-end
    return (
        <>
            <BzModal data-testid='add-to-watchlist-modal' centered show={modals['GLOBAL_SEARCH_ADDSCRIP_MODAL']} onHide={handleClose} className='modal-breeze'>
                <BzModalHeader className='modaltabs-header'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col md={11} className='d-flex justify-content-start align-items-center'>
                                <BzModalTitle data-testid='add-to-watchlist-title-label' className='font-medium font-size5 color-text'>Add to Watchlist</BzModalTitle>
                            </Col>
                            <Col md={1} className='d-flex justify-content-end align-items-center'>
                                <div data-testid='add-to-watchlist-close-icon' className='icon-16 icon-close icon-dark' onClick={handleClose}></div>
                            </Col>
                        </Row>
                    </Container>
                </BzModalHeader>
                <BzModalBody>
                    <Container fluid className='p-0'>
                        <Row className='g-0 mb-3'>
                            <Col className='d-flex justify-content-start align-items-start'>
                                <div className='font-regular font-size3 color-text'>
                                    You're adding
                                    <span data-testid='add-to-watchlist-scrip-name-label' className='font-medium text-uppercase ps-2'>
                                        {arrScripsToBeAdded?.length > 0 &&
                                            arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} {arrScripsToBeAdded?.length > 0 && arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} {arrScripsToBeAdded?.length > 0 && getScripDisplayDescription(arrScripsToBeAdded[0])} {arrScripsToBeAdded?.length === 1 ? 'Scrip' : ` & ${arrScripsToBeAdded?.length - 1} other Scrips `}
                                    </span>
                                </div>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col md={1} className='d-flex justify-content-start align-items-start'>
                                <input data-testid='add-to-watchlist-radio-button' type="radio" className='form-check-input m-0' value="AddScripTo"
                                    checked={activeOption === 'AddScripTo'} id='AddScripTo' onChange={(e) => handleOptionChange(e)} />
                            </Col>
                            <Col md={11} className='d-flex justify-content-start align-items-start'>
                                <Container fluid className='p-0'>
                                    <Row className='g-0 mb-2'>
                                        <Col className='d-flex flex-column justify-content-start align-items-start'>
                                            <div className='font-medium font-size4 color-text mb-2'>
                                                <label data-testid='add-to-watchlist-add-scrip-to-label' htmlFor='AddScripTo'>Add Scrips to</label>
                                            </div>
                                            <div className='Bzmodalselect-dropdown'>
                                                <BzDropdown>
                                                    <Dropdown.Toggle data-testid='add-to-watchlist-dropdown-toggle' disabled={activeOption === 'CreateWatchList'} className='btn-default'>{selectedOption?.name}</Dropdown.Toggle>
                                                    <Dropdown.Menu>
                                                        {arrFilteredWatchLists?.length > 0 && arrFilteredWatchLists?.map((watchList, i) =>
                                                            <Dropdown.Item data-testid={`add-to-watchlist-dropdown-element-${i}`} key={i} onClick={(e) => handleSelectOption({ target: { value: watchList?.sWatchListName, name: 'watchlist_dropdown' } })}>{`${watchList?.sWatchListName} (${watchList.scrips.length})`}</Dropdown.Item>
                                                        )}
                                                    </Dropdown.Menu>
                                                </BzDropdown>
                                            </div>
                                        </Col>
                                    </Row>
                                    {(bIsScripExists || (arrScripsToBeAdded?.length + objSelectedWatchList?.scrips?.length > nMaxScripToBeAdd)) ?
                                        <Row className='g-0 alert-warning mt-4 p-2'>
                                            <Container fluid className='g-0'>
                                                <Row className='g-0'>
                                                    <Col md={1} className='d-flex justify-content-start align-items-start'>
                                                        <div className='icon-20 icon-info icon-dark'></div>
                                                    </Col>
                                                    <Col md={11} className='d-flex justify-content-start align-items-start'>
                                                        {bIsScripExists ? <div data-testid='add-to-watchlist-scrip-exists-message-label' className='font-medium'>
                                                            {`${arrScripsToBeAdded?.length > 0 && arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.SYMBOL]} ${arrScripsToBeAdded?.length > 0 && arrScripsToBeAdded[0][WATCHLIST_GRID_INDEX.EXCHANGE]} ${arrScripsToBeAdded?.length > 0 && getScripDisplayDescription(arrScripsToBeAdded[0])}
                                                                        ${arrExistingScrips?.length > 1 ? ` & ${arrExistingScrips?.length - 1} other Scrips` : ''} already exists in "${objSelectedWatchList.sWatchListName}" watchlist.
                                                                        Choose a different watchlist to add again.`}</div> :
                                                            objSelectedWatchList?.scrips?.length === nMaxScripToBeAdd && !bIsScripExists ?
                                                                <div data-testid='add-to-watchlist-max-scrip-message-1-label' className='font-medium font-size3 color-text'>
                                                                    {`Cannot add more than ${nMaxScripToBeAdd} scrips in "${objSelectedWatchList?.sWatchListName}" watchlist. Choose a different watchlist to add again.`}
                                                                </div> :
                                                                (arrScripsToBeAdded?.length + objSelectedWatchList?.scrips?.length) > nMaxScripToBeAdd && objSelectedWatchList?.scrips?.length !== nMaxScripToBeAdd ?
                                                                    <div data-testid='add-to-watchlist-max-scrip-message-2-label' className='font-medium mt-2'>
                                                                        {`Exceeding Limit! You can add a total of ${nMaxScripToBeAdd} scrips in a watchlist. To continue adding,
                                                                    Remove some of the scrips.`}
                                                                        <Row className='g-0 my-2'>
                                                                            <Col className='d-flex justify-content-end align-items-start'>
                                                                                <BzButton data-testid='add-to-watchlist-exceeding-limit-button' type="button" className='btn btn-sm btn-outline btn-round' onClick={handleRemove}>Remove</BzButton>
                                                                            </Col>
                                                                        </Row>
                                                                    </div>
                                                                    : null}
                                                    </Col>
                                                </Row>
                                            </Container>
                                        </Row> :
                                        null}
                                </Container>
                            </Col>
                        </Row>
                        <Row className='g-0 mb-3'>
                            <Col md={1} className='d-flex justify-content-start align-items-start'>
                                <input data-testid='add-to-watchlist-create-watchlist-radio-button' type="radio" className='form-check-input m-0' id='CreateWatchList' value="CreateWatchList"
                                    onChange={(e) => handleOptionChange(e)} checked={activeOption === 'CreateWatchList'} />
                            </Col>
                            <Col className='d-flex flex-column justify-content-start align-items-start'>
                                <Row className='g-0 mb-2'>
                                    <Col className='d-flex justify-content-start align-items-start'>
                                        <div data-testid='add-to-watchlist-create-watchlist-label' className='font-medium font-size4 color-text'><label htmlFor='CreateWatchList'>+ Create New Watchlist</label></div>
                                    </Col>
                                </Row>
                                <Row className='g-0'>
                                    <Col className='d-flex justify-content-start align-items-start'>
                                        <div className='input-group'>
                                            <BzInputText data-testid='add-to-watchlist-create-watchlist-input' size='sm' type="text" maxLength='20' placeholder='Name your watchlist' className='font-regular form-control' value={strNewWatchListName} onChange={handleCreateNewWatchList} disabled={activeOption === 'AddScripTo'} />
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Container>
                </BzModalBody>
                <BzModalFooter>
                    <Container fluid className='p-0 m-0'>
                        <Row className='g-0'>
                            <form onSubmit={handleAddScripFromGlobalSearch}>
                                <Col md={8} className='mrgauto d-flex'>
                                    <BzButton data-testid='add-to-watchlist-cancel-button' type="reset" className='btn btn-md btn-outline btn-block me-3' onClick={handleCancel}>CANCEL</BzButton>
                                    <BzButton data-testid='add-to-watchlist-add-button' type="submit" className='btn btn-md btn-primary btn-block ms-3' disabled={isAddDisable}>ADD</BzButton>
                                </Col>
                            </form>
                        </Row>
                    </Container>
                </BzModalFooter>
            </BzModal>
            < GlobalSearchRemoveExtraScripModal objSelectedWatchList={objSelectedWatchList} setObjSelectedWatchList={setObjSelectedWatchList} />
        </>
    );

};

export default memo(GlobalSearchAddScripModal);